import { Row, Col } from 'src/componentes/grid';

import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import DatePicker from 'src/componentes/date-picker';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const ExperienciasSection = ({ model, resources, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.EXPERIENCIASANTERIORES]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'experienciasAnteriores' }),
    resources?.cargo,
    intl.formatMessage({ id: 'empresa' }),
    intl.formatMessage({ id: 'dataInicio' }),
    intl.formatMessage({ id: 'dataTermino' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'experienciasAnteriores' })}>
      <Row>
        {fieldMatches([resources?.cargo]) && (
          <Col md={12}>
            <Input
              model={{
                label: capitalizeFirstLetter(resources.cargo),
                value: model.getModel('cargoExperiencia').value,
                requestChange: model.getModel('cargoExperiencia').requestChange,
              }}
            />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'empresa' })]) && (
          <Col md={12}>
            <Input model={model.getModel('empresaExperiencia')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'dataInicio' })]) && (
          <Col md={12}>
            <DatePicker
              timeFormat={false}
              model={{
                label: intl.formatMessage({ id: 'dataInicio' }),
                value: model.getModel('dataInicioExperiencia').value,
                requestChange: model.getModel('dataInicioExperiencia').requestChange,
                errors: model.getModel('dataInicioExperiencia').errors,
              }}
            />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'dataTermino' })]) && (
          <Col md={12}>
            <DatePicker
              timeFormat={false}
              model={{
                label: intl.formatMessage({ id: 'dataTermino' }),
                value: model.getModel('dataTerminoExperiencia').value,
                requestChange: model.getModel('dataTerminoExperiencia').requestChange,
                errors: model.getModel('dataTerminoExperiencia').errors,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default ExperienciasSection;
